import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
0% {
  transform : rotate(0deg);
}
100% {
  transform : rotate(100deg)
}
`;

export const Container = styled.div`
  display: flex;

  transition: opacity 0.2s;
  font-weight: bold;
  flex-direction: row;
  justify-content: space-between !important;
  height: 46px;
  svg {
      width: 30px;
      min-width: 30px;
      font-size: 30px;
      }
  &:hover {
    opacity: 0.9;
  }

>h3{
  width: 100px;
  max-width: 100px;
  min-width: 100px;
  font-size: 12px;
  text-align: center;
  padding: 10px;
}

  > p {
    text-align: center;
    width: 100%;
    font-size: 18px;
 
    svg {
      width: 30px;
      min-width: 30px;
      animation: ${rotateAnimation} 1s infinite;
    }
  }
`;
